module.exports = __webpack_public_path__ + "static/media/Avion.e65e44f2.png";